import React from 'react';
import './Contact.css';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function Contact() {
    return (
        <div className='contact-page'>
            <header className='height-75'>
                <div className='container h-100 d-flex flex-column align-items-center justify-content-center text-light'>
                    <h1 className='text-center fw-semibold'>Get In Touch</h1>
                    <p className='text-center w-75 mb-5'>
                        Make us part of our journey and let's join hands and let us give you wings so that you can soar towards your dream and pen a success story.
                    </p>
                </div>
            </header>

            <div className='container my-5 d-flex justify-content-center'>
                <Form id='contact-form'>
                    <Row className='mb-3'>
                        <Col sm={12} md={6} className='mb-3 mb-md-0'>
                            <Form.Label>First Name</Form.Label>
                            <Form.Control placeholder='First name' />
                        </Col>
                        <Col sm={12} md={6}>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control placeholder='Last name' />
                        </Col>
                    </Row>

                    <Form.Group className='mb-3'>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type='email' placeholder='Enter email' />
                        <Form.Text className='text-muted'>
                            We'll never share your email with anyone else.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className='mb-3'>
                        <Form.Label>Address</Form.Label>
                        <Form.Control placeholder='Your address' />
                    </Form.Group>

                    <Row className='mb-3'>
                        <Col sm={12} md={6} className='mb-3 mb-md-0'>
                            <Form.Label>Location</Form.Label>
                            <Form.Select defaultValue="London">
                                <option>Kathmandu</option>
                                <option>Chitwan</option>
                                <option>Lalitpur</option>
                                <option>Bhaktapur</option>
                                <option>Other</option>
                            </Form.Select>
                        </Col>
                        <Col sm={12} md={6}>
                            <Form.Label>Postcode</Form.Label>
                            <Form.Control placeholder='Postcode' />
                        </Col>
                    </Row>

                    <Form.Group className='mb-3'>
                        <Form.Label>Your Message</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>

                    <Button variant="danger btn-md" type='submit'>Submit</Button>
                </Form>
            </div>

            <div className='text-center my-4'>
                <h4 className='fw-bold'>Or Call Us At</h4>
                <p className='phone-number'>
                    <a href="tel:+9779819223030" className='text-danger fs-5 text-decoration-none'>+977-9819223030</a>
                </p>
            </div>

            <div className='location-container text-light p-5'>
                <div className='container'>
                    <h2 className='text-center location-head mb-5'>Our Location</h2>
                    <div className='d-flex justify-content-center'>
                        <iframe 
                            title="Educare"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14131.036766363344!2d85.32395954641237!3d27.69383668808281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb1900052b885d%3A0x96f1620e6962944!2sEducare%20Learning%20Center%20-%20Kathmandu!5e0!3m2!1sen!2snp!4v1728470171353!5m2!1sen!2snp"
                            width="100%" 
                            height="200" 
                            style={{ border: 0 }} 
                            allowFullScreen 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;
